import styled from 'styled-components'
import { Alert } from 'shards-react'

export const AuthContainer = styled.div`
    width: 100vw;
    height: 100vh;
    overflow: hidden;
`

export const CustomizedAlert = styled(Alert)`
    font-size: 1.2em;
    letter-spacing: 1px;
    font-weight: 600;

    @media (min-width: 700px) {
        font-weight: 500;
    }
`
